import { Route } from "@/enums/route";
import { ApplicationState } from "@generated/redux/services/generated/api";

interface ApplicationSummary {
  applicationState?: ApplicationState;
}

/**
 * Determines the redirect destination for a user with no customer account.
 * Returns null if user has a customer account (no redirect needed).
 * Returns null for OPENED state (account should now exist).
 */
export function getOnboardingRedirect(
  hasCustomerAccount: boolean,
  applications: ApplicationSummary[]
): string | null {
  if (hasCustomerAccount) return null;

  if (applications.length === 0) {
    return Route.Onboarding;
  }

  const app = applications[0];
  if (!app) return Route.Onboarding;

  switch (app.applicationState) {
    case ApplicationState.Draft:
      return Route.Onboarding;
    case ApplicationState.Submitted:
    case ApplicationState.Admitted:
    case ApplicationState.Accepted:
    case ApplicationState.Rejected:
      return Route.OnboardingStatus;
    case ApplicationState.Opened:
      return null; // Will reload — account should now exist
    default:
      return Route.Onboarding;
  }
}
